import { ApplicationConfig, DEFAULT_CURRENCY_CODE, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { loadingInterceptor } from './services/interceptors/loading.interceptor';
import { authInterceptor } from './services/interceptors/auth.interceptor';
import { errorInterceptor } from './services/interceptors/error.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';
import { captchaInterceptor } from './services/interceptors/captcha.interceptor';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL'},
    provideMonacoEditor({
      baseUrl: 'assets/monaco-editor', // Changed to match angular.json output path
      defaultOptions: { scrollBeyondLastLine: false }
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimationsAsync(),
    provideAnimations(),
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor, captchaInterceptor, errorInterceptor])),
    importProvidersFrom([BrowserModule, BrowserAnimationsModule])
  ]
};